import SidePanel from '~/components/SidePanel.jsx';
import { useSchedulingFormQuery } from '~/lib/Queries';
import EditFormQuestions from '~/components/scheduling/EditFormQuestions.jsx';

const EditFormAdminScheduling = ({
    isOpen,
    onClose,
    answers,
    setAnswers,
    formId,
    eventTypeId,
}) => {
    // Query all the fields for the given form
    const { data, isLoading } = useSchedulingFormQuery(eventTypeId, formId);
    const questions = data?.questions;

    return (
        <SidePanel
            isOpen={isOpen}
            onClose={onClose}
            title="Edit Form Fields"
            showSave={true}
            showBackArrow={true}
            onSave={onClose}
            onCancel={() => {
                setAnswers({});
                onClose();
            }}
        >
            <EditFormQuestions
                questions={questions}
                isLoading={isLoading}
                answers={answers}
                setAnswers={setAnswers}
            />
        </SidePanel>
    );
};

export default EditFormAdminScheduling;
